module.exports = __webpack_public_path__ + "static/media/logo.2cba6260.svg";